import { useLimit } from '../../userInfo/hooks/useLimit';
export const usePinnedViewLimit = () => {
  return useLimit('crm-index-page-pinned-views-limit');
};